import axios from 'axios';
import config from '../config';
import {JsonHeaders} from '../constants';

export default {
    getLink(id) {
        return axios.get(config.publicPath + 'links/' + id, {
            headers: JsonHeaders
        });
    },
    getLinks(currentPage, perPage, orderField, orderDirection, group_id, user_id, url) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            "group.id": group_id,
            "user.id": user_id,
            url: url
        };
        parameters['order[' + orderField +']'] = orderDirection;
        return axios.get(config.publicPath + 'links', {
            params: parameters,
            headers: JsonHeaders
        });
    },
    createLink(formData) {
        return axios.post(config.publicPath + 'links', formData, {
            headers: JsonHeaders
        });
    },
    updateLink(id, formData) {
        return axios.put(config.publicPath + 'links/' + id, formData, {
            headers: JsonHeaders
        });
    },
    deleteLink(id) {
        return axios.delete(config.publicPath + 'links/' + id, {
            headers: JsonHeaders
        });
    }
}
